import { useTheme, Box, Typography } from "@mui/material";
import {
  WelcomeAndIntructionsPopUpRoot,
  WelcomeAndIntructionsPopUpItem,
} from "./WelcomeAndIntructionsPopUp.styles";
import RotateDesktopImg from "../../assets/instructions/camera_rotation_desktop.svg";
import ZoomDesktopImg from "../../assets/instructions/camera_zoom_desktop.svg";
import CameraPanDesktopImg from "../../assets/instructions/camera_pan_desktop.svg";
import DoubleClick from "../../assets/instructions/double_click.svg";
import RotateMobileImg from "../../assets/instructions/rotate-mobile_img.svg";
import ZoomMobileImg from "../../assets/instructions/zoom-mobile_img.svg";
import DoubleTap from "../../assets/instructions/double_tap.svg";
import { useDevice } from "../../hooks/useDevice";

export const WelcomeAndIntructionsPopUp = ({ onHandleClose }) => {
  const theme = useTheme();
  const { isTouch, isMobile, isLandscape, isDesktop } = useDevice();

  const iconsDesktop = [
    {
      alt: "Move",
      imgSrc: DoubleClick,
      title: "Move",
      descriptionMouse: "Double left click anywhere",
      descriptionTrackpad: "",
    },
    {
      alt: "Rotate",
      imgSrc: RotateDesktopImg,
      title: "Camera 360 rotation",
      descriptionMouse: "Left click (Mouse)",
      descriptionTrackpad: "Swipe (Trackpad)",
    },
    {
      alt: "Zoom",
      imgSrc: ZoomDesktopImg,
      title: "Camera zoom",
      descriptionMouse: "Wheel scroll (Mouse)",
      descriptionTrackpad: "Pinch (Trackpad)",
    },
    {
      alt: "Camera Pan",
      imgSrc: CameraPanDesktopImg,
      title: "Camera pan",
      descriptionMouse: "Middle button click + move (Mouse)",
      descriptionTrackpad: "",
    },
  ];

  const iconsMobile = [
    {
      alt: "Move",
      imgSrc: DoubleTap,
      title: "Move",
      descriptionMouse: "Double Tap anywhere",
      descriptionTrackpad: "",
    },
    {
      alt: "Rotate",
      imgSrc: RotateMobileImg,
      title: "Camera 360 rotation",
      descriptionMouse: "",
      descriptionTrackpad: "Swipe to rotate",
    },
    {
      alt: "Zoom",
      imgSrc: ZoomMobileImg,
      title: "Camera zoom",
      descriptionMouse: "",
      descriptionTrackpad: "Pinch to zoom",
    },
  ];

  const instructions = isTouch ? iconsMobile : iconsDesktop;

  return (
    <WelcomeAndIntructionsPopUpRoot>
      {instructions?.map((item, index) => (
        <>
          <WelcomeAndIntructionsPopUpItem key={index}>
            <Box
              component="img"
              src={item.imgSrc}
              alt={item.alt}
              sx={{
                width: {
                  xs: "5rem",
                  sm: "5rem",
                  md: "6rem",
                  lg: "7rem",
                  xl: "4rem",
                },
              }}
            />
            <Box
              sx={{
                textAlign: "center",
                fontWeight: 300,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontSize: "1.6rem",
                  fontWeight: 700,
                  lineHeight: 1.1,
                  marginBottom: { xs: "0.25rem", lg: "0.75rem" },
                  textAlign: "center",
                }}
              >
                {item.title}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap:
                    item.descriptionMouse && item.descriptionTrackpad && "1rem",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box component="span" sx={{ fontSize: "1.25rem" }}>
                  {item.descriptionMouse}
                </Box>
                {item.descriptionMouse && item.descriptionTrackpad && (
                  <Box component="span" sx={{ fontSize: "1.25rem" }}>
                    |
                  </Box>
                )}
                <Box component="span" sx={{ fontSize: "1.25rem" }}>
                  {item.descriptionTrackpad}
                </Box>
              </Box>
            </Box>
          </WelcomeAndIntructionsPopUpItem>
          {index + 1 < instructions?.length && (
            <>
              <Box
                sx={{
                  width: "1px",
                  background: theme?.palette?.companyColors?.black,
                  height: "100%",
                  ...(isDesktop && {
                    display: "block",
                  }),
                  ...(isMobile && {
                    display: "none",
                  }),
                  ...(isMobile &&
                    isLandscape && {
                      display: "block",
                    }),
                }}
              />
              <Box
                sx={{
                  width: "100%",
                  background: theme?.palette?.companyColors?.black,
                  height: "1px",
                  ...(isDesktop && {
                    display: "none",
                  }),
                  ...(isMobile && {
                    display: "block",
                  }),
                  ...(isMobile &&
                    isLandscape && {
                      display: "none",
                    }),
                }}
              />
            </>
          )}
        </>
      ))}
    </WelcomeAndIntructionsPopUpRoot>
  );
};
